import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { DataService } from '../../../services/data.service';

export type StaffStatus      = 'Active' | 'Inactive' | 'On Leave' | 'Resigned' | 'Terminated';
export type StaffType        = 'Teaching' | 'Non-Teaching' | 'Administrative' | 'Support';
export type StaffGender      = 'Male' | 'Female' | 'Other';
export type EmploymentType   = 'Permanent' | 'Contractual' | 'Part-time' | 'Guest';

@Component({
	selector: 'app-staff-view',
	imports: [CommonModule],
	providers: [DatePipe],
	templateUrl: './staff-view.component.html',
	styleUrl: './staff-view.component.scss',
})
export class StaffViewComponent {
	@Input() data: any;

  loading = false;
	frmData: any = {};
	user: any = '';
  datePipe = inject(DatePipe);
  currentDate: Date = new Date();
  localeDate: any = new Date().toLocaleDateString('en-IN');
  isLoginGen: boolean = false;

	constructor(public dataService: DataService) {
		//
	}

	async ngOnInit() {
    if(this.data.documents && typeof this.data.documents == 'string') {
      this.data.documents = this.dataService.str2json(this.data.documents);
    }
    if(this.data.qualifications && typeof this.data.qualifications == 'string') {
      this.data.qualifications = this.dataService.str2json(this.data.qualifications);
    }

    let erp_rem: any = localStorage.getItem("erp_rem");
    if(erp_rem && !this.user) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.dataService.deCodeUser(erp_rem);
      this.user = erp_rem;
    }

		// this.data.documents = this.data.documents?.map((item: any) => JSON.parse(item));
		// this.data.qualifications = this.data.qualifications?.map((item: any) => JSON.parse(item));
		// console.clear();
		// console.log(this.data);

    this.loading = true;
    await this.dataService.getAllRecords('users').then((res: any) => {
      if(res && res.length) {
        let retVal: any = res.filter((obj: any) => {
          return (obj.erp_key == this.user.erp_key) && (obj.user_name == this.data.emp_code || obj.user_name == this.data.mobile || obj.user_name == this.data.email);
        });

        if(retVal && retVal.length) {
          this.isLoginGen = true;
        } else {
          this.isLoginGen = false;
        }
      }
    });

  }

	openEdit(staffData: any) {
		//
	}

	async genStaffLogin(staff: any) {
		const urRole: any = this.dataService.getUserRole(staff.designation);

    this.loading = true;
    if(!this.isLoginGen) {
      this.frmData = {
        id: null, 
        erp_key: this.user.erp_key,
        display_name: staff.first_name + ' ' + staff.last_name, 
        user_name: staff.emp_code || staff.mobile || staff.email, 
        password_hash: '123', 
        user_role: [{'code': urRole.code, 'name': urRole.name}],
        desi_dept: staff.department,
        mobile_no: staff.mobile,
        email_id: staff.email,
        last_login: null,
        cur_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
        is_active: true
      };

      this.frmData.erp_key = this.user.erp_key;

      this.dataService.addNewRecord('users', this.frmData).subscribe({
        next: (response) => {
          // console.log('Response received in component:', response);
          this.loading = false;
        },
        error: (error) => {
          console.error('Error received in component:', error);
          this.loading = false;
        }
      });
    }

    this.loading = false;
	}

	getAvatarColor(id: number): string {
    const colors = ['#1a3a6b','#059669','#d97706','#7c3aed','#0284c7','#dc2626','#0d9488','#be185d'];
    return colors[id % colors.length];
  }
	getInitials(s: any): string {
		return [(s.first_name ?? ' ')[0], (s.last_name ?? ' ')[0]].join('').toUpperCase();
	}
	getStatusClass(status: StaffStatus): string {
		return { Active: 'badge-active', Inactive: 'badge-inactive', 'On Leave': 'badge-leave', Resigned: 'badge-resigned', Terminated: 'badge-terminated' }[status] ?? 'bg-secondary';
	}

	getStatusIcon(status: StaffStatus): string {
		return { Active: 'bi-check-circle-fill', Inactive: 'bi-pause-circle-fill', 'On Leave': 'bi-calendar-event-fill', Resigned: 'bi-box-arrow-right', Terminated: 'bi-x-circle-fill' }[status] ?? 'bi-circle';
	}

	getTypeClass(type: StaffType): string {
		return { Teaching: 'type-teaching', 'Non-Teaching': 'type-nonteaching', Administrative: 'type-admin', Support: 'type-support' }[type] ?? '';
	}

	getTypeIcon(type: StaffType): string {
		return { Teaching: 'bi-person-workspace', 'Non-Teaching': 'bi-tools', Administrative: 'bi-briefcase-fill', Support: 'bi-people-fill' }[type] ?? 'bi-person';
	}
  formatDate(iso: string): string {
    if (!iso) return '—';
    return new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  }
  formatCurrency(n: number | null): string {
    if (!n) return '—';
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(n);
  }
  calcAge(dob: string): string {
    if (!dob) return '—';
    const d = new Date(dob);
    const age = new Date().getFullYear() - d.getFullYear();
    return `${age} yrs`;
  }

}
